import React, { useContext } from 'react'
import injectSheet from 'react-jss'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import MyLessonsContext from '../my-lessons.context'
import Button from 'pobble-components/dist/button'
import { useBulkAction } from 'pobble-components/dist/bulk-action'
import { useDispatch } from 'react-redux'
import { deletePresentation } from '../../../../../../stores/my-presentations/my-presentations.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const BulkAction = injectSheet({
  holder: {
    height: '40px'
  }
})(({ classes, deleteLessons }) => {
  const { refreshPage } = useContext(MyLessonsContext)
  const { bulkSelectedList } = useBulkAction()
  const dispatch = useDispatch()

  return !bulkSelectedList.length ? (
    <div className={classes.holder} />
  ) : (
    <Button
      action={() => {
        openConfirmationDialog({
          theme: 'danger',
          bodyText: `You are removing ${
            bulkSelectedList.length
          } resources from your resources list. This cannot be undone.`,
          action: () =>
            Promise.all(
              bulkSelectedList.map(presentation =>
                dispatch(deletePresentation(presentation.id))
                  .then(refreshPage)
                  .catch(errorHandler)
              )
            ),
          confirmText: 'Delete',
          cancelText: 'Cancel'
        })
      }}
      tall
      dangerSecondary
      icon={<FontAwesomeIcon icon={faTrashAlt} />}>
      Delete selected
    </Button>
  )
})

export default BulkAction
